/* eslint-disable no-unreachable */
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { get, pick, map, keys, toSafeInteger } from "lodash";
import { Formik } from "formik";
import { TextField } from "@mui/material";
import Dropzone from "react-dropzone";
import { v4 as uuidv4 } from "uuid";

import {
  createCategoryApi,
  getUrlForUploadApi,
  updateCategoryApi,
  addCreditsAPI,
} from "../../apis/admin";
import { getCategoryByIdApi } from "../../apis/portal";
import { rawAxiosApi } from "../../apis/raw";
import { CreateCategorySchema } from "../../globals/validations";
import {
  POONAWALLA_DIALOG_TYPES,
  POONAWALLA_USER_ROLES_TYPES,
  PAGE_MODES,
  ROUTE_DASHBOARD,
  ROUTE_SIGNIN,
} from "../../globals/constants";
import { showErrorToaster, showSuccessToaster } from "../../globals/toaster";
import { RefreshDataActions } from "../../redux/reducers/RefreshDataReducer";
import { verifyToken } from "../../globals/utils/jwtUtils";

import PoonaWallaModal from "../PoonaWallaModal";
import PoonaWallaBasicLoader from "../PoonaWallaBasicLoader";

const CreditsModal = ({ userName }) => {
  const { authData } = useSelector(
    (store) => ({
      authData: store.auth.data || {},
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const qp = new URLSearchParams(location.search);

  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(undefined);
  const [submitted, setSubmitted] = useState(false);
  const [credits, setCredits] = useState(null);
  const handleUnmount = () => {
    // Remove Application Qparam & replace
    qp.delete("creditsmodal");
    qp.delete("name");

    history.replace({
      search: qp.toString(),
    });
    setCredits(null);
  };

  const dispatchCredits = async () => {
    try {
      if (credits <= 0) {
        return showErrorToaster("Amount should be greater than 0.");
      }

      setIsLoading(true);
      await addCreditsAPI(userDetails.id, { amount: toSafeInteger(credits) });
      dispatch(RefreshDataActions.SET_TO_REFRESH());
      showSuccessToaster("Credits Dispatched Successfully");
      handleUnmount();
    } catch (error) {
      showErrorToaster(get(error, "data.detail", "Something went wrong."));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (qp.get("creditsmodal")) {
      // IF NOT LOGGED IN
      if (!get(authData, "idToken") || !verifyToken(get(authData, "idToken"))) {
        history.push(ROUTE_SIGNIN);
      } else {
        setUserDetails({
          id: qp.get("creditsmodal"),
          name: qp.get("name"),
        });
      }
    } else {
      setUserDetails(undefined);
    }
  }, [location.search]);

  return (
    <>
      <PoonaWallaModal
        size="md"
        handleHideModal={handleUnmount}
        isActive={userDetails && userDetails.id}
        title={`Give Credits To ${get(userDetails, "name")}`}
      >
        <div className="CreateCategoryModal d-flex flex-column">
          <span className="mb-3 font-weight-bold">
            No of Credits to Dispatch
          </span>
          <TextField
            type="number"
            name="noofcredits"
            label="Credits"
            value={credits}
            onChange={(e) => setCredits(e.target.value)}
          />
        </div>
        <div className="mt-5">
          <button
            type="submit"
            className="MainButton MainButton__primary mr-3"
            onClick={handleUnmount}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={dispatchCredits}
            className={`MainButton MainButton__primary outlined ${
              isLoading && "loading"
            }`}
            disabled={isLoading}
          >
            Submit
          </button>
        </div>
      </PoonaWallaModal>
    </>
  );
};

export default CreditsModal;
